import { render, staticRenderFns } from "./NameAndNumber.vue?vue&type=template&id=ce0c8a70&scoped=true"
import script from "./NameAndNumber.vue?vue&type=script&lang=js"
export * from "./NameAndNumber.vue?vue&type=script&lang=js"
import style0 from "./NameAndNumber.vue?vue&type=style&index=0&id=ce0c8a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0c8a70",
  null
  
)

export default component.exports